function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.142 0l14.142 14.142-14.142 14.142L1.414 15.556a2 2 0 010-2.828L14.142 0z",
  fill: "#c00"
});

function SvgErrorArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.284,
    height: 28.284
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOC4yODQiIGhlaWdodD0iMjguMjg0IiB2aWV3Qm94PSIwIDAgMjguMjg0IDI4LjI4NCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2MwMDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik0wLDBIMjBhMCwwLDAsMCwxLDAsMFYyMGEwLDAsMCwwLDEsMCwwSDJhMiwyLDAsMCwxLTItMlYwQTAsMCwwLDAsMSwwLDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNC4xNDIgMCkgcm90YXRlKDQ1KSIvPjwvc3ZnPg==";
export { SvgErrorArrow as ReactComponent };